"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _configuratorModelSelector = _interopRequireDefault(require("../styles/configurator-model-selector.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var ModelHeader = function ModelHeader(props) {
  var theme = props.theme,
    disclaimerData = props.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorModelSelector["default"].headingContainer
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: theme.headingThree + " " + theme.marginBottom40 + " " + _configuratorModelSelector["default"].ModelHeader,
    text: handleNestedProp(props, 'props.headingText.title'),
    disclaimerData: disclaimerData,
    tag: "h2"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    href: handleNestedProp(props, 'props.compareLink.URL'),
    className: theme.low + " " + theme.marginBottom40 + " " + _configuratorModelSelector["default"].headerCompareCTA
  }, handleNestedProp(props, 'props.compareLink.label')));
};
var _default = ModelHeader;
exports["default"] = _default;